import React from "react";
import { Router } from "./Router";

import "./App.css";

const App = () => {
  return (
    <div>
      <Router />
    </div>
  );
};

export default App;
